/**
 * Делит сумму поровну на count частей с точностью до копейки.
 * Остаток копеек отдаётся первым частям, поэтому сумма частей всегда равна total.
 */
export function splitLogisticsCost(total: number, count: number): number[] {
    if (count <= 0) return []

    const totalKopecks = Math.round(total * 100)
    const baseKopecks = Math.floor(totalKopecks / count)
    const remainder = totalKopecks - baseKopecks * count

    return Array.from({ length: count }, (_, i) => (baseKopecks + (i < remainder ? 1 : 0)) / 100)
}
